import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Route, RouteProps } from 'react-router-dom';
import V3Layout from '../components/v3/layouts/V3Layout';
import { selectParentIsAuthenticated } from '../selectors';
import LoginRedirect from './loginRedirect';

// Module scope matters here for the same reason it does in PrivateRoute —
// see the note there.
export interface PrivateRouteWithV3LayoutProps
  extends Omit<RouteProps, 'component'> {
  // React Router's own type for this prop. Most pages routed here are
  // legacy connect()-ed components whose inferred props do not match
  // RouteComponentProps, which is exactly why RouteProps allows both.
  component: NonNullable<RouteProps['component']>;
  showStudentBanner?: boolean;
}

const PrivateRouteWithV3Layout: FC<PrivateRouteWithV3LayoutProps> = ({
  component: Component,
  showStudentBanner = true,
  ...rest
}) => {
  const isAuthenticated = useSelector(selectParentIsAuthenticated);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <V3Layout showStudentBanner={showStudentBanner}>
            <Component {...props} />
          </V3Layout>
        ) : (
          <LoginRedirect />
        )
      }
    />
  );
};

export default PrivateRouteWithV3Layout;
